import utils from "../../../utils/utils.js";

export default {

  async fetchWorkspaceFeedIsApproved(context) {
    const response = await utils.utility.fetch(
      `api/Setting/GetWorkspaceFeedIsApproved`,
      "GET",
      null,
      null
    );
    context.commit("setWorkspaceFeedIsApproved", response.data);
  },

  async changeEngagementFeedApprove(context, payload) {
    let postData = { isApproved: payload.isApproved };
    await utils.utility.fetch(
      `api/Setting/ChangeEngagementFeedApprove`,
      "POST",
      null,
      postData
    );
    context.commit("setWorkspaceFeedIsApproved", payload.isApproved);
  },

  async fetchApproveUsers(_, approvalLevel = "First") {
    const response = await utils.utility.fetch(
      `api/Editor/GetApproveUsers?approvalLevel=${encodeURIComponent(approvalLevel)}`,
      "GET",
      null,
      null
    );

    return response.data || [];
  },
};
